import React from 'react';
import { Button, Result } from 'antd';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    if (error instanceof Promise) return null;
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  retry = () => this.setState({ error: null, hasError: false });

  render() {
    const { children, fallback } = this.props;
    if (this.state.hasError) {
      return typeof fallback === 'function'
        ? fallback({ error: this.state.error, retry: this.retry })
        : fallback;
    }
    return children;
  }
}

export default function ErrorBoundaryCom({ children, height = '100%', description }) {
  return (
    <ErrorBoundary
      fallback={({ error, retry }) => (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height,
            backgroundColor: '#fff',
          }}
        >
          <Result
            status="warning"
            title={
              <div style={{ maxWidth: 480, wordBreak: 'break-word', whiteSpace: 'normal' }}>
                {typeof description === 'function'
                  ? description?.(error?.message)
                  : description || error?.message || 'Something went wrong.'}
              </div>
            }
            extra={
              <Button type="primary" onClick={retry}>
                Retry
              </Button>
            }
          />
        </div>
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
